<template>
      <nav class="navbar navbar-expand-md main_nav navbar-dark sticky" id="nav" :class="bgClass">
         <div class="container p-l-r-0 rel" style="position: relative;">
            <div class="navbar-header">
               <a class="navbar-brand p-l-r-0" href="http://therepublicofaccounting.com/">
                  <img src="../../assets/roa-logo.svg" v-if="!home">
                  <img src="../../assets/roa-logo-white.svg" v-else>
               </a>
                <!-- <a class="navbar-toggler icon" data-toggle="collapse" data-target="#myNavbar1" style="font-size:30px;">☰</a> -->
              <div class="toggle-wrap">
                  <button class="hamburger hamburger--collapse navbar-toggler icon" type="button" data-toggle="collapse" data-target="#myNavbar1">
                    <span class="hamburger-box">
                      <span class="hamburger-inner"></span>
                    </span>
                  </button>
              </div>
            </div>

            <div class="collapse navbar-collapse" id="myNavbar1">
                <ul class="nav navbar-nav navbar-left tour_step_10" >
                  <li><a href="http://therepublicofaccounting.com/about-us" data-url="#about-us" class="btn-click-t"> ABOUT US</a></li>
                  <li class="sub-menu">
                    <a href="http://therepublicofaccounting.com/business-setup" class="btn-click-t">PRODUCTS </a>
                     <ul class="sub-ddn">
                        <li><a href="http://therepublicofaccounting.com/business-setup" class="first-l-item sub-menu" >BUSINESS&nbsp;&nbsp;SET&nbsp;&nbsp;UP</a> / </li>
                        <li><a href="http://therepublicofaccounting.com/accounting-service" class="sub-menu">ACCOUNTING&nbsp;&nbsp;SERVICES</a> / </li>
                        <li><a href="http://therepublicofaccounting.com/ask-an-expert" class="sub-menu">ASK&nbsp;&nbsp;AN&nbsp;&nbsp;EXPERT</a> / </li>
                        <li><a href="http://therepublicofaccounting.com/venture-assist" class="sub-menu">VENTURE&nbsp;&nbsp;ASSIST</a></li>
                    </ul>
                    </li>
                  <li><a href="http://therepublicofaccounting.com/blog" class="btn-click-t">BLOG </a></li>
                  <li><a href="http://therepublicofaccounting.com/contact-us" class="btn-click-t">CONTACT US </a></li>
                </ul>
                <!-- <form class="form-inline my-2 my-lg-0">
                  <button class="btn btn-button " disabled type="submit">Log in</button>
                </form> -->
                <ul class="nav navbar-nav  navbar-right">
                    <li v-if="isLoggedIn"><a href="javascript://"  @click="GotoCart()" class="cart"><img src="../../assets/cart.png"> <span>{{CartCount}}</span></a></li>
                    <li v-if="isLoggedIn"> <a href="/profile"  @click="gotoProfile()" class="profile tour_step_9"><img src="../../assets/profile-dark.png"></a></li>
                    <li > 
                      <a href="javascript://" v-if="isLoggedIn" @click="logout" class="btn  btn-white">Logout</a>
                      <a href="/login" class="btn  btn-white" v-else >Login</a>
                    </li>
                </ul>
                 
               
               
            </div>
         </div>
         <b-modal id="add-cart-alert" centered  title="Accounting Manager added product to your cart." content-class="roa-alert-modal" hide-footer >
          <a href="javascript://" class="btn btn-primary" @click="GotoCart()">Go to Cart</a>
        </b-modal>
      </nav>
      
          <!-- <span v-if="isLoggedIn">
            welcome {{user.name}}
          </span> -->   
</template>
<script>
import { mapGetters } from 'vuex'
import ls from '../../services/ls';
import Pusher from 'pusher-js'
import cart from '../../services/cart'
export default {
  data:function(){
    return{
      bgClass:'',
      logocolor:'',
      logocolorText:'',
      CartCount:0,
      current_user:ls.get('_u_unique'),
      pusherKey:process.env.VUE_APP_PUSHER_KEY,
      home: true,
    }
  },
  computed:{
    ...mapGetters('auth', {
      isLoggedIn: 'isLoggedIn',
      user: 'authUser',
    })
},
created(){
   this.bgClass= this.$route.name== 'Login' ? '' :'banner-bg-bashboard';
   this.logocolorText= this.$route.name== 'Login' ? '#ffffff' :'#333';
   this.logocolor= this.$route.name== 'Login' ? '#ffffff' :'#f75511';
   this.home= this.$route.name== 'Login' ? true :false;
     this.pusher = new Pusher(this.pusherKey, {
                encrypted: true,
                cluster: 'ap2'
            })
            let that = this
            this.channel = this.pusher.subscribe('usercart')
            this.channel.bind('user-cart-update', function (data) {
                that.$emit('user-cary-update', data)
            })
            this.$on('user-cary-update', function (receiveData) {
              this.CheckUser(receiveData)
            })
},
methods: {
      logout: function () {
        this.$store.dispatch('auth/logout')
        .then(() => {
          this.$router.push('/')
        })
      },
      CheckUser(user)
      {
        // let current_user=ls.get('_u_unique');
        if(user.user==this.current_user){
          // alert('Admin added product to your cart.')
          this.$bvModal.show('add-cart-alert');
          this.GetCart()
        }
      },
      GotoCart(){
        window.location.href=process.env.VUE_APP_URL+'auth/login/auto?next=cart'+'&from='+ls.get('_u_unique_id');
      },
      GetCart(){
        // console.log(this.current_user);
        // return false;
        if(this.current_user!=null){
           cart.get({session:this.current_user}).then(response=>{
            this.CartCount=response.data.count;
          })
        }
       
      }
    },
    mounted(){
        this.GetCart();
        
    }
  
};
</script>